import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { urls } from './../../../../environments/environment';

@Injectable()
export class BoletoService {
  constructor(
    private http: HttpClient
  ) { }

  obterBoletos(contaId) {
    return this.http
      .get(urls.apiBase + '/Boletos/ObterPorContaId?contaId=' + contaId);
  }
}
